import { render, staticRenderFns } from "./SwapManage.vue?vue&type=template&id=8101ca80&scoped=true&"
import script from "./SwapManage.vue?vue&type=script&lang=js&"
export * from "./SwapManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8101ca80",
  null
  
)

export default component.exports